import moment from 'moment'

export default class SearchConsoleUtils {
  static metricAverageForPeriod(period, metric, filterMetric = metric) {
    const cleanedPeriod = period.filter(row => row[filterMetric] > 0)
    if (cleanedPeriod.length === 0) return 0

    return SearchConsoleUtils.metricSumForPeriod(cleanedPeriod, metric) / cleanedPeriod.length
  }

  static metricSumForPeriod(period, metric) {
    return period.reduce((sum, row) => { return sum + row[metric] }, 0)
  }

  static getPeriod(rows, reverseNumber, days, startDays) {
    const stDays = startDays || days
    // startDays is the number of days to extract for the very first period.
    // think about getting period for weeks (7 days). If today is Tuesday, the first period should only pull 3 days.
    if (reverseNumber === 0) return rows.slice(-stDays)

    return rows.slice(-(days * reverseNumber + stDays), -(days * (reverseNumber-1) + stDays))
  }

  static getWeekPeriod(rows, reverseNumber) {
    return SearchConsoleUtils.getPeriod(rows, reverseNumber, 7)
  }

  static getIntervalPeriod(rows, reverseNumber, interval) {
    switch (interval) {
      case 'day':
        return SearchConsoleUtils.getPeriod(rows, reverseNumber, 1, 1)
      case 'week':
        return SearchConsoleUtils.getWeekPeriod(rows, reverseNumber)
      default:
        return []
    }
  }

  static getWholePeriod(rows, count, interval) {
    switch (interval) {
      case 'day':
        return rows.slice(-count);
      case 'week': {
        return rows.slice(-count * 7)
      }
      default:
        return []
    }
  }

  static generateDummySeries(count = 5, minVal = 1000, maxVal = 2000) {
    const series = {};
    const today = new Date()

    for (let i=count-1; i>=0; i--) {
      series[moment(today).subtract(i, 'days').format('MMM DD')] = Math.floor(Math.random() * (maxVal - minVal) + minVal)
    }

    return series
  }
}



// WEBPACK FOOTER //
// ./app/utils/SearchConsoleUtils.js